import React from 'react'

import { Subsection, Upload, useMediaQueryContext } from '@fourthwall/components'
import { UploadIcon } from '@fourthwall/icons'

import { RemovableUpload, UploadedImage } from '../../../../components'
import { useSingleSeriesContext } from '../../hooks/useSingleSeriesContext'
import { FormFields } from '../../providers/SingleSeriesProvider/types'
import * as S from './styled'

export const ArtworkFields = () => {
  const media = useMediaQueryContext()
  const { form, handleUploadCoverImage, isCoverImageUploading } = useSingleSeriesContext()

  const handleFileDrop = async (files?: File[]) => {
    if (!files?.[0]) return

    await handleUploadCoverImage(files[0])
  }

  const renderUpload = () => {
    if (form.values.coverImage) {
      return (
        <S.UploadOrImageContainer>
          <RemovableUpload
            onRemove={() => {
              form.setFieldValue(FormFields.coverImage, '')
            }}
          >
            <UploadedImage image={form.values.coverImage} />
          </RemovableUpload>
        </S.UploadOrImageContainer>
      )
    }

    return (
      <S.UploadOrImageContainer>
        <Upload
          accept={{
            'image/*': [],
          }}
          title={
            media.tablet ? (
              <span>
                Drop image or <u>browse</u>
              </span>
            ) : (
              'Browse'
            )
          }
          icon={UploadIcon}
          iconSize={20}
          maxSize={10485760}
          orientation="horizontal"
          onFileDrop={handleFileDrop}
          isUploading={isCoverImageUploading}
        />
      </S.UploadOrImageContainer>
    )
  }

  return (
    <Subsection title="Cover photo">
      {renderUpload()}
      <S.ImageInfoContainer>
        <S.ImageInfo>
          Image displayed at the top of the individual video series page, serving as a banner
          background to set the tone or theme for the series.
          <S.ImageInfoRecommendedSize>Recommended size: 2464 x 600 px</S.ImageInfoRecommendedSize>
        </S.ImageInfo>
      </S.ImageInfoContainer>
    </Subsection>
  )
}
